module.exports = __webpack_public_path__ + "static/img/组织架构.bf6a77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/组织架构.png
// module id = 70Zh
// module chunks = 1